import React from 'react';
import {  Card, CardActions, CardActionArea, Button, Typography, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import { COLOR_MAP, LIGHT_COLOR_MAP, DEFAULT_COLOR } from '../constants';

import {
  BatteryChargingFull,
  SignalCellularAlt,
  Thermostat,
  Opacity,
  Sync
} from '@mui/icons-material';

export default function DeviceCard({ device }) {

    const getStaticMapImage = (size = "250x250", colorHex = "FF0000") => {
      const GOOGLE_API_KEY = "AIzaSyCraymXCAeVnYmXd4P-kRb7iGxWoKPRFCA";

      const lat = parseFloat(device.latitude);
      const lng = parseFloat(device.longitude);

      if (lat !== 0 && lng !== 0 && !isNaN(lat) && !isNaN(lng)) {
        return `https://maps.googleapis.com/maps/api/staticmap?size=${size}&language=el&zoom=8&maptype=roadmap&key=${GOOGLE_API_KEY}&markers=color:0x${colorHex.replace('#', '')}%7C${lat},${lng}`;
      }

      return "";
    };

    const isOnline = device.isOnline;
    const hasGPS = device.hasGps;
    const mapUrl = isOnline && hasGPS ? getStaticMapImage("485x300", "ee726b") : '';
    let topBgColor = '';
    let topText = '';
    let topTextColor = 'inherit';
    if (!isOnline) {
      topBgColor = 'error.light';
      topText = 'Η συσκευή είναι απενεργοποιημένη';
      topTextColor = 'white';
    } else if (!hasGPS) {
      topBgColor = 'primary.light';
      topText = 'Η συσκευή δεν έχει GPS';
    } else {
      topBgColor = 'greyCustom.soft';
      topText = 'Δεν υπάρχουν διαθέσιμες συντεταγμένες';
    }
    return (
      <Link to={`/devices/${device._id}`} style={{ textDecoration: 'none' }}>
        <Card sx={{
            borderRadius: 3,

          }}>
          <CardActionArea>

            <Box sx={{height: '300px', bgcolor: 'greyCustom.soft'}}>
              {mapUrl ? (
                <img src={mapUrl} alt="Location Map" style={{ width: '100%',height: '300px', objectFit: 'cover', borderRadius: '8px 8px 0 0' }} />
              ) : (
                <Box sx={{height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', bgcolor: topBgColor}}>
                  <Typography sx={{color: topTextColor}}>{topText}</Typography>
                </Box>
              )}
            </Box>
            <Box sx={{ p: 2 }} >
              <Typography
                variant="h6"
                sx={{
                  display: 'flex',      // Για να στοιχίζονται οριζόντια το "dot" και το κείμενο
                  alignItems: 'center',
                  whiteSpace: 'nowrap', // Απαγόρευση αλλαγής γραμμής
                  overflow: 'hidden',   // Κρύψιμο του κειμένου που περισσεύει
                  textOverflow: 'ellipsis', // Εμφάνιση των "..."
                  width: '100%'         // Εξασφάλιση ότι καταλαμβάνει όλο τον χώρο
                }}
              >
                <Box
                  component="span"
                  sx={{
                    width: 14,
                    height: 14,
                    flexShrink: 0, // ΠΟΛΥ ΣΗΜΑΝΤΙΚΟ: εμποδίζει το dot από το να μικρύνει όταν το κείμενο είναι μεγάλο
                    mr: 1,
                    borderRadius: '50%',
                    bgcolor: isOnline ? COLOR_MAP['green'] : COLOR_MAP['red'],
                    display: 'inline-block',
                    boxShadow: '0 0 4px rgba(0,0,0,0.2)'
                  }}
                />

                {/* Τυλίγουμε το όνομα σε ένα span για να δουλέψει σωστά το ellipsis μέσα στο flex */}
                <Box component="span" sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {device.name}
                </Box>
              </Typography>
              <Typography variant="h3" sx={{ my: 2 }}>{device.weight}kg</Typography>

              <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>



                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Thermostat fontSize="small" color="action" />
                  <Typography variant="body2">{device.temperature}°C</Typography>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Opacity fontSize="small" color="action" />
                  <Typography variant="body2">{device.humidity}%</Typography>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <BatteryChargingFull fontSize="small" color="action" />
                  <Typography variant="body2">{device.battery}%</Typography>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <SignalCellularAlt fontSize="small" color="action" />
                  <Typography variant="body2">{device.signal}%</Typography>
                </Box>

              </Box>
            </Box>
          </CardActionArea>
        </Card>
      </Link>
    );

};
